export const otherLegalEntities = [
  { id: '001', label: 'Breve reseña de la empresa' },
  { id: '002', label: 'Declaración de Ganancias' },
  { id: '003', label: 'Declaración de Bienes Personales' },
  { id: '004', label: 'Ventas Mensuales del Último Año' },
  { id: '005', label: 'Deudas Actualizadas' },
  { id: '006', label: 'Certificado pyme' },
  { id: '007', label: 'Manifestación de Bienes firmado por contador' },
  { id: '008', label: 'Detalle de la composición accionaria' },
  { id: '009', label: 'Último Estado Contable certificado' },
  { id: '010', label: 'Ventas Post Balance' },
  { id: '011', label: 'Estatuto de la empresa' },
  { id: '012', label: 'Actas de modificación al estatuto' },
  { id: '013', label: 'DNI frente' },
  { id: '014', label: 'DNI dorso' },
  { id: '015', label: 'Otros documentos' },
  { id: '016', label: 'Contragarantías' },
  { id: '017', label: 'Balance' },
  { id: '018', label: 'Poderes' },
  { id: '019', label: 'Otros' },
  { id: '100', label: 'Póliza de seguro' },
  { id: '101', label: 'Informe auditor' },
  { id: '102', label: 'Informe Nosis' },
  { id: '103', label: 'Balance del ejercicio anterior' },
  { id: '104', label: 'Formulario comercial' },
  { id: '105', label: 'Prenda' },
  { id: '106', label: 'Hipoteca' },
  { id: '107', label: 'Fianza' },
  { id: '108', label: 'Garantías' },
  { id: '109', label: 'Cálculo de crédito' },
  { id: '110', label: 'Mails' },
  { id: '111', label: 'Pagaré' },
  { id: '112', label: 'Revalúo de bienes del activo fijo' },
];
